/* eslint-disable react/prop-types */
import { memo } from 'react';
import { Box, Grid } from '@material-ui/core';

import './ProfileAbout.css';

function ProfileAbout({
  intro, isMobile, isTablet, nickname,
}) {
  const getViewportSize = () => {
    if (isMobile) return '80vw';
    if (isTablet) return '50vw';
    return '40vw';
  };
  return (
    <>
      <span className='profile-about-label'>About</span>
      <Box className='profile-about-main-container'>
        <Grid
          container
          justifyContent='flex-start'
          className='profile-about-container'
        >
          <Grid item>
            <div
              className='profile-about-intro-container'
              style={{
                maxWidth: getViewportSize(),
              }}
            >
              <p className='profile-about-intro'>
                {intro || `${nickname} hasn't posted their short bio yet`}
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>

  );
}

export default memo(ProfileAbout);
